import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

export function Card({ children, className = '' }: CardProps): JSX.Element {
  return (
    <section className={`rounded border border-border bg-surface-alt ${className}`}>
      {children}
    </section>
  );
}

export function CardHeader({ children, className = '' }: CardProps): JSX.Element {
  return (
    <header
      className={`px-4 py-3 border-b border-border flex items-center justify-between ${className}`}
    >
      {children}
    </header>
  );
}

export function CardTitle({ children, className = '' }: CardProps): JSX.Element {
  return <h2 className={`text-base font-semibold ${className}`}>{children}</h2>;
}

export function CardBody({ children, className = '' }: CardProps): JSX.Element {
  return <div className={`px-4 py-4 ${className}`}>{children}</div>;
}
